var map = {
	"./af.json": 840,
	"./am.json": 841,
	"./ar.json": 842,
	"./az.json": 843,
	"./be.json": 844,
	"./bg.json": 845,
	"./bn.json": 846,
	"./bs.json": 847,
	"./ca.json": 848,
	"./cs.json": 849,
	"./cy.json": 850,
	"./da.json": 851,
	"./de.json": 852,
	"./dv.json": 853,
	"./el.json": 854,
	"./en.json": 855,
	"./es.json": 856,
	"./et.json": 857,
	"./eu.json": 858,
	"./fa.json": 859,
	"./fi.json": 860,
	"./fr.json": 861,
	"./gl.json": 862,
	"./ha.json": 863,
	"./he.json": 864,
	"./hi.json": 865,
	"./hr.json": 866,
	"./hu.json": 867,
	"./hy.json": 868,
	"./id.json": 869,
	"./is.json": 870,
	"./it.json": 871,
	"./ja.json": 872,
	"./ka.json": 873,
	"./kk.json": 874,
	"./km.json": 875,
	"./ko.json": 876,
	"./ku.json": 877,
	"./ky.json": 878,
	"./lt.json": 879,
	"./lv.json": 880,
	"./mk.json": 881,
	"./ml.json": 882,
	"./mn.json": 883,
	"./ms.json": 884,
	"./nb.json": 885,
	"./nl.json": 886,
	"./nn.json": 887,
	"./no.json": 888,
	"./pl.json": 889,
	"./ps.json": 890,
	"./pt.json": 891,
	"./ro.json": 892,
	"./ru.json": 893,
	"./sd.json": 894,
	"./sk.json": 895,
	"./sl.json": 896,
	"./so.json": 897,
	"./sq.json": 898,
	"./sr.json": 899,
	"./sv.json": 900,
	"./sw.json": 901,
	"./ta.json": 902,
	"./tg.json": 903,
	"./th.json": 904,
	"./tr.json": 905,
	"./tt.json": 906,
	"./ug.json": 907,
	"./uk.json": 908,
	"./ur.json": 909,
	"./uz.json": 910,
	"./vi.json": 911,
	"./zh.json": 912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 839;